module.exports = __webpack_public_path__ + "img/banner-jc.1a2d16c6.jpg";